export default __webpack_public_path__ + "static/illustration-sweden.url-80f0f33a9e0a3f3207f17134c07e49ad.svg";